import InterviewStream from '../../components/InterviewStream';
import QuestionPanel from '../../components/QuestionPanel';
import { CurrentQuestion } from '../../types';
import { ANSWER_TIME } from '../../constants';
import styles from './style.module.scss';
import Webcam from 'react-webcam';
import { RefObject } from 'react';

interface Props {
    counter: number;
    loading: boolean;
    onNext: () => void;
    onExit: () => void;
    question: CurrentQuestion;
    webcamRef: RefObject<Webcam>;
};

/** Lays out the interview itself: the question being asked and the answer being recorded. */
function Interview(props: Props) {
    const {
        onNext,
        onExit,
        counter,
        loading,
        question,
        webcamRef,
    } = props;

    return (
        <div className={styles.container}>
            <QuestionPanel
                onNext={onNext}
                onExit={onExit}
                counter={counter}
                loading={loading}
                question={question}
            />
            <InterviewStream
                webcamRef={webcamRef}
                elapsed={ANSWER_TIME - counter}
            />
        </div>
    )
};

export default Interview;
